export default "__VITE_ASSET__JY3HTYWp__"